module.exports = __webpack_public_path__ + "img/224.42bfa25a.jpg";